import './App.css';
import Router from './page/router';

function App() {
  return <Router />;
}

export default App;